import { Link } from 'react-router-dom';

interface BrandProps {
  readonly compact?: boolean;
  readonly linked?: boolean;
}

export function Brand({ compact = false, linked = true }: BrandProps) {
  const content = (
    <>
      <span className="brand-mark" aria-hidden="true" />
      {!compact && (
        <span className="brand-word">
          <span>Satr</span>
          <small dir="ltr">PDF</small>
        </span>
      )}
      <span className="sr-only">Satr PDF</span>
    </>
  );

  return linked ? <Link className="brand" to="/">{content}</Link> : <div className="brand">{content}</div>;
}
